
import { useAuth } from "@/components/AuthProvider";
import { toast } from "@/hooks/use-toast";

export const useSessionHandler = () => {
  const { user, isSessionExpired, refreshSession } = useAuth();

  const handleSessionError = async () => {
    console.log("Checking session status:", { isSessionExpired, hasUser: !!user });
    
    if (!user) {
      toast({
        variant: "destructive",
        title: "Authentication Required",
        description: "Please log in to save drawings.",
      });
      return false;
    }
    
    if (isSessionExpired) {
      console.log("Attempting to refresh session before save");
      try {
        const refreshed = await refreshSession();
        
        if (!refreshed) {
          toast({
            variant: "destructive",
            title: "Session Expired",
            description: "Your session has expired. Please log in again to save your work.",
          });
          return false;
        }
        
        console.log("Session refreshed successfully");
        return true;
      } catch (error) {
        console.error("Session refresh error:", error);
        toast({
          variant: "destructive",
          title: "Authentication Error",
          description: "There was a problem with your authentication. Please try logging out and back in.",
        });
        return false;
      }
    }
    
    return true; // Session is valid
  };

  return {
    isSessionExpired,
    handleSessionError,
    isLoggedIn: !!user
  };
};
